import styled from "styled-components";
import TopBackground from "../defaultPage/top-background.svg"
import BottomBackground from "../defaultPage/bottom-background.svg"

export const PageHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
  background: 
    url(${TopBackground}) no-repeat top center / 100% 1024px,
    url(${BottomBackground}) no-repeat bottom center / 100% 1024px,
    #F1F1F1;
`

export const PageContent = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  width: min(1112px, 80vw);
  min-height: min(674px, 80vh);
  background-color: #FFFFFF;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 20px 40px 40px 40px;
`
